import React, { useState } from "react";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const photos = [
    "./photos/img-1.jpg",
    "./photos/img-2.jpg",
    "./photos/img-3.jpg",
    "./photos/img-4.jpg",
    "./photos/img-5.jpg",
    "./photos/img-6.jpg",
    "./photos/img-7.jpg",
    "./photos/img-8.jpg",
    "./photos/img-9.jpg",
    "./photos/img-10.jpg",
    "./photos/img-11.jpg",
    "./photos/img-12.jpg",
    "./photos/img-13.jpg",
    "./photos/img-14.jpg",
    "./photos/img-15.jpg",
    "./photos/img-16.jpg",
    "./photos/img-17.jpg",
    "./photos/img-18.jpg",
    "./photos/img-19.jpg",
    "./photos/img-20.jpg",
    "./photos/img-21.jpg",
    "./photos/img-22.jpg",
    "./photos/img-23.jpg"
  ];

  const openImage = (img) => {
    setSelectedImage(img);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-container">
      {/* <h1>Image Gallery</h1> */}
      <div className="image-grid1">
        {photos.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openImage(img)}
          >
            <img src={img} alt={`Gallery item ${index + 1}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fullscreen-overlay" onClick={closeImage}>
          <div className="fullscreen-image-container">
            <img src={selectedImage} alt="Full screen" />
            <button className="close-button" onClick={closeImage}>
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
